import { render, staticRenderFns } from "./VigieRulesInput.vue?vue&type=template&id=4898a4aa&scoped=true"
import script from "./VigieRulesInput.vue?vue&type=script&lang=js"
export * from "./VigieRulesInput.vue?vue&type=script&lang=js"
import style0 from "./VigieRulesInput.vue?vue&type=style&index=0&id=4898a4aa&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4898a4aa",
  null
  
)

export default component.exports